const contentManagementCMSTable = [
  {
    header: "Title, Content Type",
    dataProp: "Title",
    width: "25%",
    hideArrowSort: false,
    textwrap: true,
    canSort: true,
  },
  {
    header: "Categories",
    dataProp: "HtmlTagList",
    datatype: "html",
    width: "8%",
    canSort: false,
  },
  {
    header: "Create Date",
    dataProp: "CreatedOn",
    datatype: "dateTime",
    width: "8%",
    canSort: true,
  },
  {
    header: "Updated",
    dataProp: "UpdatedDate",
    datatype: "dateTime",
    width: "8%",
    canSort: true,
  },
  {
    header: "Enabled",
    dataProp: "IsEnabled",
    width: "4%",
    canSort: true,
    isBool: true,
  },
  {
    header: "Content",
    dataProp: "LibraryVisible",
    width: "4%",
    canSort: true,
    isBool: true,
  },
  {
    header: "Cert.",
    dataProp: "UseForCertification",
    width: "4%",
    canSort: true,
    isBool: true,
  },
  {
    header: "Enhanced Search",
    dataProp: "IsAI",
    width: "5%",
    canSort: true,
    isBool: true,
  },
  {
    header: "Enhanced Search Admin",
    dataProp: "IsAiAdmin",
    width: "7%",
    canSort: true,
    isBool: true,
  },
  {
    header: "ECHO Status",
    dataProp: "AiStatus",
    width: "6%",
    canSort: true,
  },
  {
    header: "Enhanced Search Tags",
    dataProp: "AiOnlyTags",
    datatype: "html",
    width: "8%",
    canSort: false,
  },
];

export { contentManagementCMSTable };
